import React from 'react';
import { UL, LI, H6, P } from '../../AbstractElements';

const FileList = ({ myfile }) => {
  return (
    <UL className='simple-list files-content flex-row list-group'>
      {myfile.map((data, i) => (
        <LI key={i} className='folder-box d-flex align-items-center'>
          <div className='d-flex align-items-center files-list'>
            <div className='flex-shrink-0 file-left'>
              <i className={data.icon}></i>
            </div>
            <div className='flex-grow-1 ms-3'>
              <H6>{data.name}</H6>
              <P>
                {data.modify}, {data.size}
              </P>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
};

export default FileList;
